import React from 'react';
import { CAExceptionRequestLink } from './help-links';
import { InfoPanel } from '../../info-panel';

interface Props {
  title?: string;
}

export const ApprovalMessage = ({ title = 'Approval required' }: Props) => {
  return (
    <InfoPanel
      type="warning"
      title={title}
      message={
        <p>
          This discount is more than the allowed value of 30%. When you submit your changes, your approval request will
          be sent to the Slack channel {<CAExceptionRequestLink />}. Subscription changes will be pending until the
          discount is approved.
        </p>
      }
    />
  );
};
